import { AxiosResponse } from 'axios';
import apiInterceptor from '../utils/axios';
import { Interaccion } from '../types/Interacciones/Interaccion';
import { GenericResponse } from '../types/Response/GenericResponse';

const SERV_BACK: string = process.env.REACT_APP_API_ESPOL_ADS || '';
const APIINTERACCION = 'api/Catalog/interacciones/';

export default class InteraccionServices {

    static async PostInteraccion(inter: Interaccion): Promise<GenericResponse> {
        try {
            const response: AxiosResponse<any> = await apiInterceptor.post(`${SERV_BACK}${APIINTERACCION}`,
                inter,
                {
                    headers:{
                        "Content-type" : "application/json",
                    },
                }
            );
            if (response.status === 200) {
                return {
                    status: response.status,
                    message: 'Operación completada con éxito',
                };
            } else {
                console.error('Respuesta no exitosa:', response.status);
                return {
                    status: response.status,
                    message: `Error: Código de estado ${response.status}`,
                };
            }    
        } catch (error) {
            console.error('Error al realizar la solicitud:', error);
            return {
                status: 500,
                message: 'Error al realizar la solicitud',
            };
        }
    }
}